import React, { useState } from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import AlertIcon from '../../assets/AlertIcon';
import Theme from '../ui/Theme';

const useStyles = makeStyles(() => ({
  mainContent: {
    width: '443px',
    height: '153px',
    marginLeft: '16px',
    marginTop: '24px',
    background: Theme.palette.secondary.main,
  },
  popupBtnContainer: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  deleteBtn: {
    padding: '0px 60px',
    height: '42px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  cancelBtn: {
    padding: '0px 70px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  contentTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: 'black',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  contentSubTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    /* identical to box height */
    display: 'flex',
    justifyContent: 'center',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: '8px',
  },
  attentionContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  attentionText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    marginLeft: '12px',
    color: Theme.palette.quad.main,
  },
  threeDots: {
    fontFamily: 'Montserrat',
    fonttyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    justifyContent: 'center',
    color: '#EB5757',
    marginBottom: '8px',
  },
  durationText: {
    fontFamily: 'Montserrat',
    fonttyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    justifyContent: 'center',
    color: '#EB5757',
    marginBottom: '8px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  frame34: {
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: 'black',
  },
  subTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));

const AssignJourneyToAllConfirmation = (props) => {
  const classes = useStyles();

  const [viewConfirm, setViewConfirm] = useState(true);

  const closePopup = () => {
    setViewConfirm(false);
    props.close();
  };
  const submit = () => {
    closePopup();
    props.submit();
  };

  return (
    <Modal
      isOpen={viewConfirm}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '475px',
          height: '150px',
          background: '#FFFFFF',
        },
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Grid container className={classes.frame34}>
            <Grid item>
              <Grid container>
                <Grid item>
                  <div className={classes.title}> Are you sure of this change?</div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="column" justifyContent="center" alignContent="center">
            <Grid item>
              <Grid container className={classes.attentionContent}>
                <Grid item style={{ marginTop: '4px' }}>
                  <AlertIcon />
                </Grid>
                <Grid item>
                  <div className={classes.attentionText}>
                    Dealer assign journey to all selected roles in the dealership?
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={classes.popupBtnContainer}>
              <Button variant="contained" disableElevation className={classes.cancelBtn} onClick={closePopup}>
                Cancel
              </Button>
              <Button variant="contained" className={classes.deleteBtn} onClick={submit}>
                <div style={{ color: '#EB5757' }}> Confirm </div>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AssignJourneyToAllConfirmation;
